<template>
  <div class="main">
    <Resource :title="$t('schoolResource')"/>
  </div>
</template>

<script>
import Resource from '@/views/resource/private/index'

export default {
  name: 'TeacherResource',
  components: {
    Resource
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.main {
  padding: 0px !important;
}
</style>
